import React from "react";
import Container from "@mui/material/Container";
import BlogsContainer from "containers/Blogs";
import PageTitle from "components/PageTitle";
import { tracker } from "library/tracker";
import { MOBILE_GUTTER } from "components/allInOneDashboard/constants/mobileTheme";

const Blogs = () => {
    React.useEffect(() => {
        tracker.pageView();
    }, []);

    return (
        <Container
            maxWidth="xl"
            sx={{
                px: { xs: MOBILE_GUTTER, md: 4, lg: 7.5 },
                pb: { xs: 2, md: 3 },
            }}
        >
            <PageTitle
                heading="Blogs"
                showBackToDashboard={true}
                disableBreadcrumb={true}
            />
            <BlogsContainer />
        </Container>
    );
};

export default Blogs;
